import Vue from 'vue';
import BaseProxy from './base-proxy';


/**
 * Class RuleProxy
 */
class RuleProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/invoice-robotics-api/api', parameters);
  }

  getRules(options = {}) {
    return this.submit('post', `${this.endpoint}/get-all-rules`, null, options);
  }

  createRule(tag) {
    const toast = {
      success: Vue.i18n.t('rule.ruleCreated'),
      error: Vue.i18n.t('rule.ruleCreatedError'),
    };
    return this.submit('post', `${this.endpoint}/create-rule`, tag, {
      toast,
    });
  }

  updateRule(invoice) {
    const toast = {
      success: Vue.i18n.t('rule.ruleUpdated'),
      error: Vue.i18n.t('rule.ruleUpdatedError'),
    };
    return this.submit('post', `${this.endpoint}/update-rule`, invoice, { toast });
  }

  execRule(id) {
    const options = { toast: { success: Vue.i18n.t('rule.exec') } };
    return this.submit('post', `${this.endpoint}/exec-rules`, { rules: [id] }, options);
  }

  deleteRule(id) {
    const toast = {
      success: Vue.i18n.t('rule.ruleDeleted'),
    };
    return this.submit('post', `${this.endpoint}/delete-rule`, { id }, { toast });
  }
}

export default RuleProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/rule-proxy.js